import React, { useState,useEffect } from 'react'
import { useParams } from "react-router-dom";
import { baseUrl } from "../../utils/apiActions/dashboardApi";
import AgentDetails from '../../Component/AgentDetails'
import SweetAlert from "react-bootstrap-sweetalert";
import DataTable from 'react-data-table-component';
import { agentLocationColumns } from '../../utils/data/agentColumns';
import { toastError, toastSuccess } from '../../utils/toastrResponse';
import moment from 'moment';
import { customStyles } from '../../utils/data/essential';
import AssignAgentLocation from '../../Component/agents/AssignAgentLocation';
import { Button, Modal } from 'react-bootstrap';
import { editAgent } from '../../utils/roles';
import useAxios from '../../hooks/useAxios';

const Agent = () => {
    const [agentData, setAgentData] = useState();
    const [subscriberId, setSubscriberId] = useState();
    const [subscriberData, setSubscriberData] = useState();
    const [data, setData] = useState([]);
    const [row, setRow] = useState()
    const [locationData, setLocationData] = useState([]);
    const [showAlert, setShowAlert] = useState(false)
    const [showLocationModal, setShowLocationModal] = useState(false);
    const user = JSON.parse(localStorage.getItem("user"));
    const roles = JSON.parse(localStorage.getItem("roles"));
  
    const columns = agentLocationColumns(setShowAlert, setRow, roles,setShowLocationModal)
    const { agentId } = useParams();
    const axiosInstance = useAxios()
    const fetchAgent = async () => {
      const url = `${baseUrl}/agents/${agentId}`;
      try {
        const res = await axiosInstance.get(url);
        if (res.status <= 200 && res.status <= 300) {
          setAgentData(res.data);
          setSubscriberId(res.data.subscriberId);
        }
      } catch (error) {
        console.error(error)
      }
    };
  useEffect(() => {
    fetchAgent()
  }, [])
  // Fetch subscriber data
  const fetchSubscriberData = async () => {
    const url = `${baseUrl}/subscribers/${subscriberId}`;
    if (subscriberId) {
      try {
        const res = await axiosInstance.get(url);
        if (res.status <= 200 && res.status <= 300) {
          setSubscriberData(res.data);
        }
      } catch (error) {
        console.error(error)
      }
    }
  };
  useEffect(() => {
    fetchSubscriberData();
    
  }, [subscriberId]);
  const fetchAgentLocation = async () => {
    const res = await axiosInstance.get(`/agents/${agentId}/locations`)
    setData(res.data);
  }
  useEffect(() => {
    fetchAgentLocation();
  }, []);

  const fetchLocationById = () => {
    if (data.length > 0) {
      const locationPromises = data.map((item) =>
        fetch(`${baseUrl}/locations/${item.locationId}/details`, {
          method: "GET",
          headers: new Headers({
            Authorization: "Bearer " + user.access_token,
            Accept: "application/json",
            "Content-Type": "application/json",
          }),
        })
          .then((response) => response.json())
          .catch((error) =>
            console.error("Error fetching location data:", error)
          )
      );

      Promise.all(locationPromises)
        .then((locationDataArray) => {
          setLocationData(locationDataArray);
        })
        .catch((error) =>
          console.error("Error fetching location data:", error)
        );
    }
  }
  useEffect(() => {
    // Fetch data for each locationId from the second endpoint
    fetchLocationById();
  }, [data]);
  const mergeArrays = (firstArr) => {
    return firstArr.map((item) => {
      return {
        ...item,
        locations: locationData,
        firstName: subscriberData?.firstName,
        lastName: subscriberData?.lastName,
        phoneNumber: subscriberData?.phoneNumber,
      };
    });
  };
  let combinedData = []
  if (locationData.length > 0) combinedData = mergeArrays(data, locationData);
  
  // remove location on agent
  const removeLocationOnAgent = async () => {
    const dataToSend = {
      ...row,
      endDatetime: moment().format("YYYY-MM-DDTHH:mm:ss"),
    };
    const url = `${baseUrl}/agents/${agentId}/locations`;
    await axiosInstance({
      url,
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data:dataToSend,
    })
      .then((res) => {
        if (res.status >= 200 && res.status <= 300) {
          setShowAlert(false);
          toastSuccess("Agent Suspended successfully");
          fetchAgentLocation();
        } else {
          toastError("Could not suspend an agent");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div>
      <div
        className='card-header d-flex justify-content-center'
        style={{ backgroundColor: "#124db1" }}
      >
        <h3 className='font-family' style={{ color: "#FFF", fontWeight: 600 }}>
          Agent Details
        </h3>
      </div>
      <AgentDetails
        agent={agentData}
        names={`${subscriberData?.firstName} ${subscriberData?.lastName}`}
        phoneNumber={subscriberData?.phoneNumber}
      />
      <div className='d-flex justify-content-center'>
        <h4 className='mt-4' style={{ fontWeight: 600 }}>
          {`${combinedData.length < 1 ? "No " : ""}Location${
            combinedData.length > 1 ? "s" : ""
          } Assigned to this Agent`}
        </h4>
      </div>
      {roles?.some((role) => role.id === editAgent) && (
        <div className='d-flex justify-content-end mr-3'>
          <Button
            className='custom-btn-color'
            onClick={() => setShowLocationModal(true)}
          >
            Add location
          </Button>
        </div>
      )}
      <div className='table-responsive datatables dataValidation-Wrap thead-primary pr-3 pl-3 mr-2'>
        <DataTable
          columns={columns}
          data={combinedData}
          responsive={true}
          customStyles={customStyles}
          highlightOnHover
          striped
          noHeader
        />
      </div>
      <SweetAlert
        title='You are about to remove this location from agent, Are you sure?'
        onConfirm={removeLocationOnAgent}
        onCancel={() => setShowAlert(false)}
        show={showAlert}
        showConfirm={true}
        showCancel={true}
        type='warning'
        cancelBtnBsStyle='primary'
        confirmBtnBsStyle='success'
        cancelBtnText='No'
        confirmBtnText='Yes'
      />
      {/* Assign location to the agent */}
      <Modal
        size='md'
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={showLocationModal}
      >
        <Modal.Header closeButton onClick={() => setShowLocationModal(false)}>
          <h5> Add Location to Agent</h5>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#f0f0fa" }}>
          <AssignAgentLocation
            agentId={agentId}
            setStep={() => {}}
            hide={() => setShowLocationModal(false)}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Agent

